import { ExternalLink } from "lucide-react";
import { formatDate } from "./formatters";
import { hostnameOf } from "./sourceUrl";

interface SourceArticleTextProps {
  title?: string | null;
  sourceUrl?: string | null;
  publishedAt?: string | null;
  text?: string | null;
}

const NO_TEXT = "No article text was kept for this one.";

/** One source article: title, a link to the original, and its full extracted text. */
const SourceArticleText = ({ title, sourceUrl, publishedAt, text }: SourceArticleTextProps) => (
  <div className="space-y-2 rounded-md border p-3">
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
      <span className="font-medium">{title || "Untitled article"}</span>
      <span className="text-xs text-muted-foreground">{formatDate(publishedAt)}</span>
      {sourceUrl ? (
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-xs text-primary-text hover:underline"
        >
          Read original ({hostnameOf(sourceUrl)})
          <ExternalLink className="h-3 w-3 shrink-0" />
        </a>
      ) : null}
    </div>
    {text ? (
      <div
        tabIndex={0}
        aria-label="Article text"
        className="max-h-80 overflow-y-auto whitespace-pre-wrap rounded bg-muted/40 p-3 text-sm"
      >
        {text}
      </div>
    ) : (
      <p className="text-xs italic text-muted-foreground">{NO_TEXT}</p>
    )}
  </div>
);

export default SourceArticleText;
